module.exports = __webpack_public_path__ + "img/productlb1.2ff210ec.png";